import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { APIHeaderService } from '../../_services/header/API-header';
import * as CryptoJS from 'crypto-js';
import { APIEntityService } from '../../_services/entity/API-entity';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import {Location} from '@angular/common';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';








@Component({
  selector: 'app-header-id-details',
  templateUrl: './header-id-details.component.html',
  styleUrls: ['./header-id-details.component.css']
})
export class HeaderIdDetailsComponent implements OnInit {
  public entityID: any;
  public response:any;
  public panCard:any;
  public showentitydetails:any;
  public showentitybutton:boolean=true;
  
  entityDetails: FormGroup;
  submitted: boolean = false;





  constructor(  private fb: FormBuilder,
    private router: Router,
      private _route: ActivatedRoute,
    private hs: APIHeaderService,
    private es: APIEntityService,
    private $modal: $ModalManagerService,
    private _location: Location,



    
    ) {  
      
     this.getEntityIdDetails();

    }
    getEntityIdDetails(){
 this._route.params.subscribe((params) => {
        if(params['entityID']){
      this.entityID = params['entityID'];
     console.log(this.entityID);
     this.hs.getHeaderDetails(this.entityID)
        .subscribe(async r => {
          console.log("response :", r);
          this.response=r;
          console.log("response1 :", this.response);
          this.showentitydetails=true;
          this.showentitybutton=false

        })
      }
 })
    
        

      
      

            
      
    }
    onSubmit() {
      this.submitted = true;
      if (this.entityDetails.invalid) {
        console.log("invalid");

        this.showentitydetails=false;


        console.log("form 1 :", this.entityDetails);
        return; 
      }
      else {
      this.entityID = this.entityDetails.get('entityID').value;
      console.log(this.entityID);
   this.hs.getHeaderDetails(this.entityID)
      .subscribe(async r => {
        if (r) {
        console.log("response :", r);
        this.response=r;
        console.log("response1 :", this.response);
        this.showentitydetails=true;
        }
        else {
          this.$modal.errorModal({
            title: 'Header Details',
            msg: 'Header Name Not Found'
          });
          this.showentitydetails=false;
        }
      })
      }
    }

    
        backClicked() {
    console.log("clickedddddddddddd");
    this.router.navigateByUrl('/');
      }

  // Pan(datas){
  //   // console.log("datas ",datas);
  //   const key = '18bcd0b950de300fb873788958fde988fec9b478a936a3061575b16f79977d5b';
  //    const IV = '2e11075e7b38fa20e192bc7089ccf32b';
         
  //    //for(let encrypted of encryptedValues) {
  //    const decrypted = CryptoJS.AES.decrypt({ ciphertext: CryptoJS.enc.Hex.parse(datas) }, CryptoJS.enc.Hex.parse(key), { 
  //        iv: CryptoJS.enc.Hex.parse(IV), 
  //        mode: CryptoJS.mode.CBC
  //       }); 
  //   //console.log("datas ",decrypted.toString(CryptoJS.enc.Utf8));  
  //   this.panCard= decrypted.toString(CryptoJS.enc.Utf8);
  //  }

   
//   download(file1,entityId,filename){ 

//     var data = {
//       "Entity_ID": entityId,
//       "FileType": "KYC",
//       "FileName": file1
//     } 

//   this.es.headerFileDownload(data).subscribe(r => {

//     this.downloadFile(r, file1);
//     this.$modal.successModal({
//       title: 'Entity Summary',
//       msg: 'File has been downloaded Successfully'
//     });   
//   })

// }
// private downloadFile(res: any, filename: string): void {
//   const url = window.URL.createObjectURL(res);
//   const a = document.createElement('a');
//   document.body.appendChild(a);
//   a.setAttribute('style', 'display: none');
//   a.href = url;
//   a.download = filename;
//   a.click();
//   window.URL.revokeObjectURL(url);
//   a.remove();
// }
get f() { return this.entityDetails.controls; }

  ngOnInit() {
    this.entityDetails = this.fb.group({
     
      //number: ['', [Validators.required, Validators.pattern("[0-9]{10}")]],
      entityID: ['', [Validators.required,Validators.minLength(3),Validators.maxLength(6)]]
    })
  }
  

}
